import React, { ReactElement } from "react";
import Avatar from "react-avatar";
import { Col, Row } from "react-bootstrap";

import { ProjectTask, ProjectTaskDueDate } from ".";
import { ProjectTaskLabelsList } from "./ProjectTaskLabelsList";

interface ProjectTaskCardProps {
	task: ProjectTask;
	onClick?: () => void;
}

export const ProjectTaskCard = ({
	task,
	onClick,
}: ProjectTaskCardProps): ReactElement => {
	if (!task) {
		return <span>Untitled</span>;
	}

	const memberAvatars = task.members.map((member: any, index: number) => (
		<Avatar
			round
			key={index}
			name={member.user ? member.user.fullName : "NA"}
			size="25"
			textSizeRatio={2}
			color="#dfe1e6"
			fgColor="#172b4d"
			style={{ marginRight: 8 }}
		/>
	));

	const cover = task.cover();

	const handleClick = () => {
		if (onClick) {
			onClick();
		}
	};

	return (
		<div
			role="button"
			tabIndex={0}
			onClick={handleClick}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					handleClick();
				}
			}}
			className="kanban-task-card"
		>
			{cover ? <img src={cover} className="task-card-image" alt="" /> : null}
			<div className="card-wrapper">
				{task.labels.length > 0 && (
					<ProjectTaskLabelsList
						task={task}
						fontSize={8}
						paddingHorizontal={5}
						paddingVertical={2}
					/>
				)}

				<span className="task-title">{task.name}</span>
				<Row>
					<Col>
						<div
							style={{
								marginTop: 10,
								marginBottom: 10,
							}}
						>
							{memberAvatars}
						</div>
						<span style={{ opacity: 0.5 }}>#{task.id}</span>
					</Col>
					<Col style={{ alignSelf: "flex-end", textAlign: "right" }}>
						<ProjectTaskDueDate task={task} dateFormat="MMM DD" />
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default ProjectTaskCard;
